const Api = {
  messageDeliver: "/message/deliver",
  learnType: "/learn/type",
  learnList: "/learn/list",
  commentUpdate: "/learn/comment/update",
  commentList: "/learn/comment/list",
  settingFetch: "/setting/fetch"
};

export { Api };
